import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import PropTypes from "prop-types";
AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default function AppLayout({ children }) {
  return (
    <>
      {children}
      <ToastContainer rtl closeOnClick theme="colored" toastClassName="custom-toast-font" />
    </>
  );
}
